import OocOrderInterface from "@/interface/app/ooc/order.interface";
import { OocOrderType } from "@/types/app/ooc/order.type";
import { OOC_ORDER_STATUS } from "@/enums/ooc/ooc-order.enum";
import moment from "moment-timezone";
import { PriceMoney } from "@/modules/location";
import { OocTab } from "@/modules/ooc/tab";
import OocTabInterface from "@/interface/app/ooc/tab.interface";

export default class OocOrder implements OocOrderInterface {
  name: string = "";
  status: string = "";
  location_id: string = "";
  external_status: string = "";
  source: string = "";
  id: string = "";
  payment_status: string = "";
  total: string = "";
  tab_id: string = "";
  tab: OocTabInterface = new OocTab({});
  created_at: string = "";
  location_name: string = "";
  business_name: string = "";
  country_id: string = "";
  business_id: string = "";
  message: string = "";
  selected: boolean = false;
  items: Array<any> = [];
  logs: Array<any> = [];
  constructor(data?: OocOrderType) {
    if (data) {
      this.name = data.name;
      this.location_id = data.location_id;
      this.status = data.status;
      this.external_status = data.external_status;
      this.id = data.id;
      this.tab_id = data.tab_id;
      this.tab = new OocTab(data.tab);
      this.source = data.source;
      this.created_at = data.created_at;
      this.message = data.message;
      this.logs = data.logs || [];
      this.location_name = data.location?.name;
      this.business_name = data.location?.business?.name;
      this.business_id = data.location?.business?.id;
      this.country_id = data.location?.business?.country_id;
      this.payment_status = data?.payment_status;
    }
    this.setStatus(data);
    this.formatTimeForOrder(data);
    this.calculateTotal(data);
  }
  private setStatus(data) {
    this.status = OOC_ORDER_STATUS[data.status] ?? "PENDING";
  }
  /**
   * time formatter
   * @return {void}
   */
  private formatTimeForOrder(data): void {
    const formattedTime = moment(data.created_at);
    if (!formattedTime.isValid()) {
      this.created_at = "";
    }
    this.created_at = formattedTime?.utc(true)?.fromNow();
  }

  /**
   * time formatter
   * @return {string}
   */
  public formatTime(datetime): string {
    const formattedTime = moment(datetime);
    if (!formattedTime.isValid()) {
      return "";
    }
    return formattedTime?.utc(true)?.fromNow();
  }

  /**
   * calculate total for this order
   * @param data
   * @private
   */
  private calculateTotal(data) {
    let total = 0;
    data.items?.forEach((item) => {
      total += item.price * item.quantity;
    });
    this.total = new PriceMoney({ amount: total }).getPricePackage();
  }
}
